export interface MoveAction<ActionId extends string = string> {
  readonly id: ActionId;
  readonly label: string;
  readonly disabled?: boolean;
  readonly disabledReason?: string;
}

export interface MoveRequestState {
  readonly busy?: boolean;
  readonly disabled?: boolean;
}

export function canRequestMove(
  action: Pick<MoveAction, "disabled">,
  { busy = false, disabled = false }: MoveRequestState = {},
) {
  return !busy && !disabled && action.disabled !== true;
}

export function buildMoveActionAccessibleLabel(
  itemLabel: string,
  action: Pick<MoveAction, "label">,
) {
  return `${action.label} for ${itemLabel}`;
}

export function dispatchMoveRequest<ActionId extends string>(
  action: MoveAction<ActionId>,
  state: MoveRequestState,
  onMoveRequest: (actionId: ActionId) => void,
) {
  if (!canRequestMove(action, state)) return false;

  onMoveRequest(action.id);
  return true;
}

export function reorderItems<Item>(
  items: readonly Item[],
  fromIndex: number,
  toIndex: number,
): readonly Item[] {
  const indicesAreValid =
    Number.isInteger(fromIndex) &&
    Number.isInteger(toIndex) &&
    fromIndex >= 0 &&
    fromIndex < items.length &&
    toIndex >= 0 &&
    toIndex < items.length;

  if (!indicesAreValid || fromIndex === toIndex) return items;

  const reordered = [...items];
  const [item] = reordered.splice(fromIndex, 1);
  reordered.splice(toIndex, 0, item!);
  return reordered;
}
